import type { TestProviderPartialProps } from '@wix/yoshi-flow-bm/testkit';
import {
  exportServiceMocks,
  appSettingsMocks,
  hubJobImportMocks,
} from '@wix/bex-core/testkit';
import {
  whenRequest,
  when,
} from '@wix/yoshi-flow-bm/testkit/http-client/client';
import { dataExtensionServiceMocks, tagsServiceMocks } from '../test-utils';
import { asyncJobMocks } from '../test-utils/AsyncJobMocks';
import { itemsSelectionAPIHttpClientMocks } from '../test-utils/ItemsSelectionMocks';

export function wixPatternsTestProviderPropsOverrides(
  overrides?: TestProviderPartialProps,
): TestProviderPartialProps {
  return {
    ...overrides,
    mocks: [
      ...(overrides?.mocks ?? []),
      ...exportServiceMocks(whenRequest).mocks,
      ...appSettingsMocks(whenRequest),
      ...dataExtensionServiceMocks(whenRequest).mocks,
      ...asyncJobMocks(whenRequest).mocks,
      ...tagsServiceMocks(whenRequest).mocks,
      ...itemsSelectionAPIHttpClientMocks(whenRequest),
      // Data-movement (Hub Job) mocks so the CSV import flow completes in
      // consumer tests. Defaults to a COMPLETED job (see hubJobImportMocks).
      ...hubJobImportMocks(whenRequest, when).mocks,
    ],
  };
}
